import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { formatNumber } from '../../../../../utils/numberFormatter';

const ProductPlanSelector = ({
  categories = [],
  selectedCategory = '',
  selectedProductPlan = null,
  onSelectPlan,
  onChangeCategory,
  loading = false
}) => {
  const selectedCategoryData = categories.find(cat => cat.id === selectedCategory);

  if (loading) {
    return (
      <div className="row justify-content-center mt-4 rg-tile-grid rg-tile-grid--product-plans">
        {[...Array(3)].map((_, index) => (
          <div className="col-md-3" key={index}>
            <div className="card category-option rg-tile rg-plan-tile--skeleton" aria-hidden="true">
              <div className="card-body text-center">
                <div className="rg-plan-tile__stack">
                  <Skeleton height={22} width={138} />
                  <Skeleton height={34} width={126} />
                  <Skeleton height={20} width={44} borderRadius={10} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!selectedCategoryData || !selectedCategoryData.plans || !Array.isArray(selectedCategoryData.plans) || selectedCategoryData.plans.length === 0) {
    return null;
  }

  const categoryPlans = selectedCategoryData.plans.filter((plan) => (plan.max_capital_effective ?? 0) > 0);

  if (categoryPlans.length === 0) {
    return null;
  }

  return (
    <div className="row justify-content-center mt-4 rg-tile-grid rg-tile-grid--product-plans">
      {categoryPlans.map((plan) => {
        const maxEffective = plan.max_capital_effective ?? 0;

        return (
          <div className="col-md-3" key={plan.id}>
            <div
              className={`card category-option rg-tile ${selectedProductPlan?.id === plan.id ? 'selected' : ''}`}
              onClick={() => onSelectPlan(plan)}
              style={{ cursor: 'pointer' }}
            >
              <div className="card-body text-center">
                <h5 className="card-title">{plan.label}</h5>
                <div className="rg-category-capital mt-2" aria-label={`Capital máximo ${formatNumber(maxEffective)}`}>
                  <span className="rg-category-capital__amount">${formatNumber(maxEffective)}</span>
                  <span className="rg-category-capital__chip">MAX.</span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductPlanSelector;
